import React, {Component} from "react";
import axios from "axios";
import {API_URL} from "../config";
import AdSense from "react-adsense";

class Ads extends Component {
    state = {
        advertise: "",
        style: this.props.style
    }

    componentDidMount() {
        axios.get(
            API_URL + '/api/v1/advertise/banner',
            {
                params: {
                    position: 4
                },
                headers: {
                    'Authorization': "ads_add_campus_551275"
                }
            }
        ).then((res) => {
            let advertise_div;
            if (res.data.data.advertise) {
                advertise_div = <><img
                    alt="ads_banner"
                    style={{width: "100%", cursor: "pointer", pointerEvents: "visible"}}
                    src={res.data.data.advertise.thumbnail_url} onClick={() => {
                    this.advertiseClick(res.data.data.advertise.id, res.data.data.advertise.redirection_url)
                }}/></>
            } else {
                advertise_div = <AdSense.Google
                    style={{display: "block"}}
                    client="ca-pub-7382781619073845"
                    slot="7509075349"
                    format="horizontal"/>
            }
            this.setState({
                advertise: advertise_div
            })
        })
    }

    advertiseClick(ads_id, url) {
        axios.post(
            API_URL + '/api/v1/advertise/banner/' + ads_id,
            {},
            {
                headers: {
                    'Authorization': "ads_add_campus_551275"
                }
            }).then((res) => {
            let a = window.document.createElement("a");
            window.document.body.appendChild(a);
            a.style = "display: none";
            a.setAttribute('target', '_blank')
            a.setAttribute('href', url)
            a.click();
            window.document.body.removeChild(a);
        });
    }

    render() {
        return (
            <div style={this.props.style}>
                {this.state.advertise}
            </div>
        )
    }
}

export default Ads;
